import React from "react";
import { useNavigate } from "react-router-dom";
import "./OurPartners.css";
import railTelImg from "../../Component/Images/bgbanner.png";
import railTelLogo from "../../Component/Images/railtellogo.png";
import ciscoImg from "../../Component/Images/ciscoimg.png";
import ciscoLogo from "../../Component/Images/ciscologo.png";
import redingtonImg from "../../Component/Images/redingtonimg.png";
import redingtonLogo from "../../Component/Images/redingtonlogo.png";

const OurPartners = () => {
    const navigate = useNavigate();
    const partnerData = [
        {
            id: 1,
            image: railTelImg,
            logoImage: railTelLogo,
            description: `RailTel, a "Navratna" Central Public Sector Enterprise is an ICT provider and one of the largest neutral telecom infrastructure providers in the country owning a Pan-India optic fiber network. The OFC network covers important towns & cities of the country and several rural areas.`,
        },
        {
            id: 2,
            image: ciscoImg,
            logoImage: ciscoLogo,
            description: "Cisco is a global leader in networking, cybersecurity, and IT infrastructure. Founded in 1984 and headquartered in San Jose, California, USA, Cisco designs, manufactures, and sells networking hardware, software, telecommunications equipment, and high-technology services and products.",
        },
        {
            id: 3,
            image: redingtonImg,
            logoImage: redingtonLogo,
            description: "Our increasingly digitised world, connected and surrounded by technology and innovation, has transformed the way we live and work. While this intersection between the digital and physical world has opened doors to limitless possibilities, it has also brought several challenges in its wake. The most significant challenge being Technology Friction – the gap between the rate of technological innovation and the speed of its adoption.",
        }
    ];

    const handleClick = () => {
        navigate("/contact_us");
    };

    return (
        <div id="partnerSection">
            <div className="partners-hero">
                <div className="partners-heroL">
                    <div className="partners-text">
                        <p>BastionEx Partnership Opportunities</p>
                        <h2>Simplified Success Through Powerful Partnerships</h2>
                        <div className="partners-text-p">
                            <p>
                                Expand your reach. Grow your business. Unlock new revenue streams.
                            </p>
                            <p>Whether you're a reseller, solution provider, technology partner,
                                strategic ally, or affiliate — the possibilities are endless.
                            </p>
                        </div>
                    </div>
                    <div className="partners-button">
                        <button className="primary-btn" onClick={handleClick}>Become a Partner</button>
                        {/* <button className="secondary-btn">Explore Partnerships</button> */}
                        {/* Temporary btn with scroll functionality ->*/}
                        <a
                            href="#partnersContainer"
                            className="secondary-btn"
                            style={{ display: 'inline-block', textDecoration: 'none', textAlign: 'center' }}
                            onClick={(e) => {
                                e.preventDefault();
                                const element = document.getElementById('partnersContainer');
                                if (element) {
                                    element.scrollIntoView({
                                        behavior: 'smooth',
                                        block: 'start',
                                    });
                                }
                            }}
                        >
                            Explore Partnerships
                        </a>
                    </div>
                </div>
                <div className="partners-heroR">
                    <img src="./partner-hero.png" alt="Partner Hero" />
                </div>
            </div>

            <div className="partners-content">
                <p>BastionEx Partner Network</p>
                <h2>Partner with a fast-growing global alliance</h2>
                <p>
                    Expand your business with our global network, unmatched partner advantages,
                    and market growth resources.
                </p>
            </div>

            <div id="partnersContainer" className="container">
                <div className="partners-list">
                    {partnerData.map((partner, index) => (
                        <div
                            key={partner.id}
                            className={`partner-item ${index % 2 !== 0 ? "reverse" : ""} partner-item-col`}
                        >
                            <div className="partner-img">
                                <img src={partner.image} alt={partner.name} />
                            </div>
                            <div className="partner-details">
                                <img src={partner.logoImage} alt={partner.name} className="partner-logo" />
                                <p>{partner.description}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="partners-connect">
                    <p>Partner with us</p>
                    <h2>Ready to partner with BastionEx?</h2>
                    <p className="p-last">
                        Join the Freshworks partner program to get started, or contact our team to discuss your interest.
                    </p>
                    <button className="secondary-btn" onClick={handleClick}>Become a Partner</button>
                </div>
            </div>
        </div>
    );
};

export default OurPartners;